import { useMutation } from 'react-query';
import { useCurrentUser, useToastProvider } from '@qualio/ui-components';
import { useTranslation } from 'react-i18next';
import templateApi from '../services/templateApi';
import { formErrorMessageForToast } from '../utils/backEndErrorMessages';
import { useNavigate } from 'react-router-dom';

export const useCreateTemplateDraft = () => {
  const { companyId } = useCurrentUser();
  const { showToast } = useToastProvider();
  const navigate = useNavigate();
  const { t } = useTranslation();

  return useMutation((templateUuid: string) => templateApi.createTemplateDraft(companyId, templateUuid), {
    onSuccess: (data) => {
      showToast({
        description: t('template.create.success'),
        status: 'success',
        title: t('common.toast.success'),
        'data-cy': 'toast-create-draft-success',
      });
      navigate(`/doc-templates/${data.id}?intent=edit`);
    },
    onError: (error) => {
      showToast({
        description: formErrorMessageForToast(t('template.create.errors.failed'), error),
        status: 'error',
        title: t('common.toast.error'),
        'data-cy': 'toast-create-draft-error',
      });
    },
  });
};
